/* unplugin-vue-components disabled */import { render } from "./logistics.vue?vue&type=template&id=cad24c0a&scoped=true"
import script from "./logistics.vue?vue&type=script&lang=js"
export * from "./logistics.vue?vue&type=script&lang=js"

import "./logistics.vue?vue&type=style&index=0&id=cad24c0a&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cad24c0a"]])

export default __exports__